var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5293C27.6372 1.5293 35 7.5689 35 14.5293C35 18.165 33.0283 21.5154 29.7344 23.9229L29.4121 24.1533C28.7972 24.5802 28.4195 25.3441 28.5615 26.1436L28.5977 26.3037C29.0512 28.0178 29.852 30.1742 31.2695 32.4551L31.5605 32.9121C31.5689 32.9248 31.5731 32.9357 31.5752 32.9443C28.0506 31.8913 25.5301 30.0816 23.7549 28.2441L23.4062 27.873C22.9681 27.3929 22.3273 27.145 21.6787 27.2109L21.5498 27.2285C20.3994 27.42 19.2156 27.5293 18 27.5293C8.36283 27.5293 1 21.4897 1 14.5293C1.00001 7.5689 8.36284 1.5293 18 1.5293Z",
    fill: "#FFF4D9",
    stroke: "#BB8D6C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogue);
export default __webpack_public_path__ + "static/media/dialogue.f33508430980086d37c7015724abd718.svg";
export { ForwardRef as ReactComponent };